exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#project-application-component[data-v-0e79d730]{font-size:14px}.applicant-information dt[data-v-0e79d730]{margin-bottom:.5em}.applicant-information dd[data-v-0e79d730]{margin-bottom:1em;padding-bottom:1em;border-bottom:1px solid #eee}.badge[data-v-0e79d730],.expert-applicants th[data-v-0e79d730],.normal-applicants th[data-v-0e79d730]{cursor:pointer}.applicant-information[data-v-0e79d730]{height:680px;overflow-y:scroll;border:1px solid #ccc;padding:.5em}.applicant-information .panel-footer[data-v-0e79d730]{background-color:#fcfcfc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0e79d730","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/ProjectApplication.vue
// module id = 194
// module chunks = 0